module.exports = __webpack_public_path__ + "img/header-logo-png.2da1e53d.png";